<template>
    <div>
        <div style="height:0.1rem"></div>
        <div class="content_text" v-text="data"></div>
        <div class="img_44 content_center cursor" @click="$emit('close')"></div>
    </div>
</template>

<script>
module.exports = {
    props: ['data'],
    data() {
        return {}
    },
    created() {
        console.log('err', this.data)
    },
}
</script>

<style scoped>
.content_text {
    width: 100%;
    height:1.2rem;
    margin:auto;
    margin-top:1rem;
    text-align: center;
    font-size: 0.36rem;
    color: #000000;
    white-space: pre-wrap;
}
</style>